// FLAGS: consent
// Reads the Cookiebot consent object off `window` and answers whether a set of categories is
// consented to; the only cookie-consent primitive in the app.
export const getCookiebotConsent = () => {
  if (typeof window !== "undefined" && window.Cookiebot?.consent) {
    return {
      necessary: window.Cookiebot.consent.necessary,
      preferences: window.Cookiebot.consent.preferences,
      statistics: window.Cookiebot.consent.statistics,
      marketing: window.Cookiebot.consent.marketing,
    };
  }
  return null;
};

export const isCookiebotReady = (): boolean => {
  return (
    typeof window !== "undefined" &&
    window.Cookiebot !== undefined &&
    window.Cookiebot.consent !== undefined
  );
};

// FLAGS: consent
// Fails closed: no Cookiebot object means false. A read, not the enforcement; posthog.service.ts uses it
// as is, while CookieConsentGuard checks `isCookiebotReady` itself and still renders before Cookiebot loads.
export const hasConsentFor = (categories: string | string[]): boolean => {
  if (!isCookiebotReady()) return false;

  const consent = getCookiebotConsent();
  if (!consent) return false;

  const cats = Array.isArray(categories) ? categories : [categories];
  return cats.every((category) => consent[category as keyof typeof consent]);
};
